/**
 * Boot splash: the Tübinger mug filling along the SRM chart, instead of a
 * sentence. The SVG is decorative; `label` is what a screen reader hears.
 */

import { srmToHex } from '@beerwright/core';
import type { ReactNode } from 'react';
import { BeerGlass } from '@/components/recipe/beer-glass';

/**
 * What the app says while the workspace is still arriving.
 *
 * Shared rather than typed twice: the shell shows it while hydration runs, and
 * a record page shows it while the sync client catches up. Two spellings would
 * read as two different waits.
 */
export const WORKSPACE_SPLASH_LABEL = 'Opening your workspace…';

/**
 * @param children - Shown under the mug, for a wait that has gone on long
 *   enough to need a way out.
 */
export function OpeningSplash({
  label,
  children,
}: {
  readonly label: string;
  readonly children?: ReactNode;
}) {
  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center gap-4 bg-background"
      role="status"
      aria-live="polite"
    >
      <BeerGlass color={srmToHex(10)} loading className="h-20 w-24" />
      <span className="sr-only">{label}</span>
      {children}
    </div>
  );
}
